const routeImporter = requireContext => requireContext.keys()
    .map(fileName => requireContext(fileName))
    .reduce((routes, route) => {
      if(_.isObject(route.default)){
        _.forEach(route.default, (obj,k) => {
          routes[k] = obj
        })
      }
      return routes
    }, {});

export default routeImporter;



//////////////////
// WEBPACK FOOTER
// ../core/resources/routeImporter.js
// module id = null
// module chunks = 